import { useContext, useEffect, useState } from "react";
import { Autocomplete, CircularProgress, IconButton, Menu, Paper, TextField, Typography } from "@mui/material";
import { useQuery, useQueryClient } from "react-query";
import { getBranchOfficesByCompany } from "./services/api";
import { AuthContext } from "context/AuthContext";
import RestaurantIcon from '@mui/icons-material/Restaurant';
import { Tooltip } from "@mui/material";

export function BranchOfficeSelect({ width = 300, externalOnClick = null }) {
  const { updateBranchOfficeSelected, branchOfficeSelected, toogleBranchOffice } = useContext(AuthContext)
  const user = JSON.parse(localStorage.getItem('mqadusr'))
  const queryClient = useQueryClient()
  const [options, setOptions] = useState([])

  const { data, isLoading } = useQuery(
    ['branchOfficeByCompany', user.company._id], () => getBranchOfficesByCompany(user.company._id),
    { refetchOnWindowFocus: false }
  )

  useEffect(() => {
    if (data !== undefined && data !== null && data !== "") {
      setOptions(data.data)
      if (branchOfficeSelected !== null) {
        const branch_office_selected = data.data.find(bo => branchOfficeSelected._id === bo._id)
        toogleBranchOffice(branch_office_selected !== undefined ? branch_office_selected : null)
      }
    }
  }, [data])

  useEffect(() => {
    queryClient.invalidateQueries('branchOfficeByCompany')
  }, [updateBranchOfficeSelected])

  if (isLoading) {
    return <CircularProgress />
  }

  return (
    <Autocomplete
      disablePortal
      size="small"
      id="combo-box-demo"
      options={options}
      sx={{ width: width }}
      value={options.length === 0 ? null : branchOfficeSelected}
      renderInput={(params) => <TextField {...params} label="Sucursales" />}
      onChange={(event, newValue) => {
        toogleBranchOffice(newValue)
        if (externalOnClick !== null) { externalOnClick() }
      }}
    />
  )
}

export function BranchOfficeSelectHeader() {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  return (<>
    <Tooltip title="Sucursales">
      <IconButton
        onClick={handleClick}
        size="small"
        sx={{ ml: 2 }}
        aria-controls={open ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        <RestaurantIcon />
      </IconButton>
    </Tooltip>
    <Menu
      anchorEl={anchorEl}
      id="account-menu"
      open={open}
      onClose={handleClose}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: 'visible',
          filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
          mt: 1.5,
          '& .MuiAvatar-root': {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
          },
          '&:before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            bgcolor: 'background.paper',
            transform: 'translateY(-50%) rotate(45deg)',
            zIndex: 0,
          },
        },
      }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
      <div style={{ margin: "5px 10px" }}>
        <BranchOfficeSelect />
      </div>
    </Menu>
  </>)
}

export function BranchOfficeSelectOnPage() {
  return (
    <div style={{ width: "100%", height: "89vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
      <Paper sx={{ padding: 10 }}>
        <Typography variant="body1" component="p" sx={{ marginBottom: 2, fontWeight: "bold", fontSize: 24 }}> Selecciona una sucursal para continuar </Typography>
        <BranchOfficeSelect width="100%" />
      </Paper>
    </div>
  )
}